<template>
	<div>
		<div class="uni-margin-wrap hidden">
			<swiper class="swiper fullwidth  height500r" circular :indicator-dots="indicatorDots" :autoplay="autoplay"
				:interval="interval" :duration="duration">
				<swiper-item v-for="(item, index) in advList" @click="goDetail(item)" :key="index">
					<img class="fullwidth  height500r" mode="aspectFill" :src="item.img" />
				</swiper-item>
			</swiper>
		</div>


		<div class="uni-list">
			<block v-for="(item, index) in shopList" :key="index">
				<div class="uni-list-cell" hover-class="uni-list-cell-hover" @click="selectShop(item)">
					<div class="uni-media-list">
						<img class="width100 height100" :src="item.img?item.imgArr[0]:''" />
						<div class="uni-media-list-body paddingl10">
							<div class="size3">{{ item.name }}</div>
							<div class="margint40r size5 color3">
								{{ item.area }} {{ item.address }}
							</div>

						</div>
					</div>
				</div>
				<!-- #ifdef APP-PLUS -->
				<div class="ad-view" v-if="(index > 0 && (index+1) % 10 == 0)">
					<ad :adpid="adpid" @error="aderror"></ad>
				</div>
				<!-- #endif -->
			</block>
		</div>
		<uni-load-more :status="status" :icon-size="16" :content-text="contentText" />
	</div>
</template>

<script>
	import uniLoadMore from '@/components/uni-load-more/uni-load-more.vue';
	//
	//var app = getApp();

	export default {
		components: {
			uniLoadMore
		},
		data() {
			return {
				action:"",
				
				advList: [],
				indicatorDots: true,
				autoplay: true,
				interval: 2000,
				duration: 500,
				//------------------
				shopList: [],
				page: 1,
				totalPage: 0,
				status: 'more',
				adpid: '',
				contentText: {
					contentdown: '上拉加载更多',
					contentrefresh: '加载中',
					contentnomore: '没有更多'
				}
			};
		},
		onShareAppMessage() {
			return {
				title: '欢迎体验',
				path: '/pages/goods/list/list'
			}
		},
		onNavigationBarButtonTap(e) {
			this.$router.push({ path: '/' }); 
		},
		created() {
			//uniapp转vue后，onLoad() 参数来源变化：options → this.$route.query 或 this.$route.params
			var options=this.$route.query || {};
			this.action=options.action;
			if(this.action=='select_shop'){
				window.$utils.uniapi.setNavigationBarTitle({ title:"选择附近的店铺" })
			}else{
				window.$utils.uniapi.setNavigationBarTitle({ title:"查找附近店铺" })
			}

		},
		mounted() {
			
			//避免reLaunch错误
			this.page = 1;
			this.getShopList();
		},
		onPullDownRefresh() {
			//this.getAdvList();
			this.page = 1;
			this.getShopList();
			window.$utils.uniapi.stopPullDownRefresh();
		},
		onReachBottom() {
			this.status = this.page >= this.totalPage ? "nomore" : 'more';
			if (this.page < this.totalPage) {
				this.page++;
				this.getShopList();
			}
		},
		methods: {
			getAdvList() {
				this.$axios.request({
						url: window.$config.url.getGoodsList,
						data: {
							advPositionId: 1
						}
					})
					.then(res => {
						if (!!res.code == true && res.code == window.$config.resCode.SUCCESS) {
							window.$utils.uniapi.stopPullDownRefresh();
							this.advList = res.data.list;

						} else if (!!res.msg == true) {
							window.$utils.uniapi.showToast({
								title: res.msg,
								icon: "none"
							});
						} else {
							window.$utils.uniapi.showToast({
								title: "不成功",
								icon: "none"
							});
						}
					});

			},
			
			getShopList: function(params) {
				console.log("查询list");
				var that = this;
				var user = window.$utils.uniapi.getStorageSync("user") || {};

				if (typeof params == "undefined") {
					params = {};
				}
				params.type = window.$config.shopType; //xs_node";
				params.page = that.page;
				params.name = !!this.keyword == true ? this.keyword : "";
				params.state = "pass";

				that.$axios.request( {url: window.$config.url.getShopList,  data: params })
					.then(res => {
						console.log(JSON.stringify(res),window.$config.resCode.SUCCESS);
						//if(!that.commonResponse(res))return;
						if(!!res.code==true && res.code==window.$config.resCode.SUCCESS){
							var shopList = res.data.list;
							//数据合并
							if (params.page > 1) {
								shopList = that.shopList.concat(shopList);
							}
							that.shopList = shopList;
							that.totalPage = res.data.totalPage;
							that.status = that.page>=that.totalPage?"nomore":'more';
							
							
							if(that.action=='select_shop' && that.shopList.length==1){
								console.log("选点时，单店直接返回");
								setTimeout(function(){
									window.$utils.uniapi.setStorageSync("selectedShop",that.shopList[0]);

									that.$router.replace({ name: "tabbar_index_index",query:{} });
									//that.$router.replace('/')

									// window.$utils.uniapi.reLaunch({ 
									// 	url:"/pages/tabbar/index/index" ,
									// 	success(res){console.log(res);},
									// 	fail(res){console.log(res);}
									// });
								},600);
								
							}
						}else if(!!res.msg==true){
							window.$utils.uniapi.showToast({ title:res.msg,icon:"none" });
						}else{
							window.$utils.uniapi.showToast({ title:"不成功",icon:"none" });
						}
					})
					.catch(error => {
						console.log('完整错误信息:', error);
						console.log('请求URL:', error.config);
						console.log('响应头:', error.response);
						alert("不成功");
					});
					
					
				// this.$axios.request({
				// 		url: window.$config.url.getShopList,
				// 		data: params
				// 	})
				// 	.then(res => {
				// 		if(!!res.code==true && res.code==window.$config.resCode.SUCCESS){
				// 			var shopList = res.data.list;
				// 			//数据合并
				// 			if (params.page > 1) {
				// 				shopList = that.shopList.concat(shopList);
				// 			}
				// 			that.shopList = shopList;
				// 			that.totalPage = res.data.totalPage;
				// 			that.status = that.page>=that.totalPage?"nomore":'more';
				// 			if(that.action=='select_shop' && that.shopList.length==1){
				// 				console.log("选点时，单店直接返回");
				// 				setTimeout(function(){
				// 					window.$utils.uniapi.setStorageSync("selectedShop",that.shopList[0]);
				// 					uni.reLaunch({ 
				// 						url:"/pages/tabbar/index/index" ,
				// 						success(res){console.log(res);},
				// 						fail(res){console.log(res);}
				// 					});
				// 				},600);
				// 			}
				// 		}else if(!!res.msg==true){
				// 			uni.showToast({ title:res.msg,icon:"none" });
				// 		}else{
				// 			uni.showToast({ title:"不成功",icon:"none" });
				// 		}
				// 	});
			},

			selectShop(obj) {
				var id = obj.id;
				var name = obj.name;
				window.$utils.uniapi.setStorageSync('selectedShop', obj);
				
				//清理数据
				window.$utils.uniapi.removeStorageSync('cartGoodsList');
				
				//跳转
				console.log("selectShop finish to index");
				//uni.switchTab({ url:"/pages/tabbar/index/index" });
				window.$utils.uniapi.reLaunch({ url:"/pages/tabbar/index/index"  });
			},
			

			goDetail(e) {
				console.log(e);
				this.$router.push({path:"/goods_detail",query:{id:e.id}});
					
			},

			aderror(e) {
				console.log("aderror: " + JSON.stringify(e.detail));
			}
		}
	};
</script>

<style scoped>
	.banner {
		height: 180px;
		overflow: hidden;
		position: relative;
		background-color: #ccc;
	}

	.banner-img {
		width: 100%;
	}

	.banner-title {
		max-height: 42px;
		overflow: hidden;
		position: absolute;
		left: 15px;
		bottom: 15px;
		width: 90%;
		font-size: 16px;
		font-weight: 400;
		line-height: 21px;
		color: white;
		z-index: 11;
	}

	.uni-media-list-logo {
		width: 90px;
		height: 70px;
	}

	.uni-media-list-body {
		height: auto;
		justify-content: space-around;
	}

	.uni-media-list-text-top {
		height: 37px;
		font-size: 14px;
		overflow: hidden;
	}

	.uni-media-list-text-bottom {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
	}
</style>


// WEBPACK FOOTER //
// src/views/shop/list.vue